export const APP_SETTINGS_VERSION_0 = 0;
export const APP_SETTINGS_VERSION_1 = 1;
export const APP_SETTINGS_VERSION_2 = 2;
export const APP_SETTINGS_VERSION_3 = 3;
export const APP_SETTINGS_VERSION_4 = 4;
export const APP_SETTINGS_VERSION_LATEST = APP_SETTINGS_VERSION_4;
//# sourceMappingURL=versions.js.map